var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRapport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 110,
    viewBox: "0 0 87 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.1627 22.831L61.6529 3.23254C59.365 1.14791 56.3704 0 53.221 0H12.2692C5.50398 0 0 5.30084 0 11.8164V98.1836C0 104.699 5.50398 110 12.2692 110H74.7308C81.496 110 87 104.699 87 98.1836V31.4149C87 28.1817 85.6013 25.0529 83.1627 22.831ZM79 27H60C59 27 57 26 57 24.707V7L79 27ZM74.7308 104.5H12.2692C9.19411 104.5 5.5 101.145 5.5 98.1836V11.8164C5.5 8.85478 9.10873 5 12.1839 5H52.2V24.707C52.2 28.8533 55.7025 32.2266 60.0077 32.2266H81.5V98.1836C81.5 101.145 77.8059 104.5 74.7308 104.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRapport);
export default __webpack_public_path__ + "static/media/rapport.f6fb0d63731e4a239c9eabc5b78aff84.svg";
export { ForwardRef as ReactComponent };